import React, {useEffect, useState} from 'react';
import {Col, Row} from 'react-bootstrap';
import {service as OfflineDataService} from "../../../Services/OfflineDataService";

import {useMakePageRequest} from "../../../Hooks/RequestHooks";
import {usePermission} from "../../../Hooks/PermissionHooks";
import {SbMap} from "../../Common/SbMap";

export const QuantVeg = (props) => {
    const makePageRequest = useMakePageRequest();
    const permission = usePermission();

    const [transects, setTransects] = useState([])

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        makePageRequest(
            _ => OfflineDataService.Download(null, null, props.sampleEvent.sampleEventId),
            ({Transects}) => {
                setTransects(Transects)
            }
        );
    };

    return (
        <Row className="sb-transect-list">
            {
                !!transects.length &&
                <Col xs={12} className="sb-transect-list-node">
                    <h2 className="sb-children-list-title">Transect Locations</h2>
                    <SbMap
                        Lat={transects[0].latitude}
                        Lng={transects[0].latitude}
                        Zoom={11}
                        Markers={transects.map(transect => ({
                            key: transect.transectId,
                            lat: transect.latitude,
                            lng: transect.longitude,
                            accuracy: transect.accuracy,
                            marker: !permission('authenticated_user') ? 'circle' : 'both',
                            content: <div>Transect {transect.name}</div>
                        }))}
                    />
                </Col>
            }
        </Row>
    )
};


